export enum Language {
  ENGLISH = 'English',
  FILIPINO = 'Filipino',
}
